import { Radio, SimpleGrid } from "@mantine/core";

import { useTranslation } from "~/hooks/use-typed-translation";

type ServiceTimeSlot = {
  id?: string;
  startHour: number;
  startMinute: number;
  endHour: number;
  endMinute: number;
  startTime: string;
};

interface ServiceTimeOptionsProps {
  serviceDate: Date | string;
  slots: ServiceTimeSlot[];
}

export const ServiceTimeOptions = ({ serviceDate, slots }: ServiceTimeOptionsProps) => {
  const { i18n } = useTranslation();

  return (
    <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="xs" verticalSpacing="xs" maw={420}>
      {slots.map(slot => {
        const startDate = new Date(serviceDate);
        startDate.setHours(slot.startHour, slot.startMinute, 0, 0);

        const endDate = new Date(serviceDate);
        endDate.setHours(slot.endHour, slot.endMinute, 0, 0);

        return (
          <Radio
            key={slot.startTime}
            value={slot.startTime}
            label={`${startDate.toLocaleTimeString(i18n.language, {
              timeStyle: "short",
            })} - ${endDate.toLocaleTimeString(i18n.language, {
              timeStyle: "short",
            })}`}
          />
        );
      })}
    </SimpleGrid>
  );
};
